/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentType
 */
export interface PaymentType {
    /**
     * The type of payment method.
     * @type {string}
     * @memberof PaymentType
     */
    name: PaymentTypeNameEnum;
    /**
     * Additional information about the payment.
     * @type {string}
     * @memberof PaymentType
     */
    infos?: string;
}


/**
 * @export
 */
export const PaymentTypeNameEnum = {
    Cash: 'CASH',
    Check: 'CHECK',
    WireTransfer: 'WIRE_TRANSFER',
    CreditCard: 'CREDIT_CARD'
} as const;
export type PaymentTypeNameEnum = typeof PaymentTypeNameEnum[keyof typeof PaymentTypeNameEnum];


/**
 * Check if a given object implements the PaymentType interface.
 */
export function instanceOfPaymentType(value: object): value is PaymentType {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PaymentTypeFromJSON(json: any): PaymentType {
    return PaymentTypeFromJSONTyped(json, false);
}

export function PaymentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentType {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'infos': json['infos'] == null ? undefined : json['infos'],
    };
}

export function PaymentTypeToJSON(json: any): PaymentType {
    return PaymentTypeToJSONTyped(json, false);
}

export function PaymentTypeToJSONTyped(value?: PaymentType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'infos': value['infos'],
    };
}

